import React from 'react';
import { Box, Container, Paper } from '@mui/material';

const ContinuationShell = ({ children, cardSx, maxWidth = 'sm', pageSx }) => (
  <Box
    data-testid="continuation-shell"
    sx={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      bgcolor: '#f4f6fb',
      px: 2,
      py: 6,
      ...pageSx,
    }}
  >
    <Container maxWidth={maxWidth}>
      <Paper
        data-testid="continuation-shell-card"
        elevation={0}
        sx={{
          p: { xs: 3, sm: 4 },
          borderRadius: 3,
          border: '1px solid #dfe5f0',
          backgroundColor: '#ffffff',
          ...cardSx,
        }}
      >
        {children}
      </Paper>
    </Container>
  </Box>
);

export default ContinuationShell;
